import React from 'react';
import errorLogger from '../utils/errorLogger';

/**
 * Error Boundary Component
 * Catches React component errors and logs them
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }
    
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }
    
    componentDidCatch(error, errorInfo) {
        // Log error to error logging service
        errorLogger.error('React component error', error, {
            componentStack: errorInfo.componentStack,
            errorBoundary: this.props.name || 'Unknown'
        });
        
        this.setState({
            error,
            errorInfo
        });
    }
    
    render() {
        if (this.state.hasError) {
            // Custom fallback UI
            if (this.props.fallback) {
                return this.props.fallback(this.state.error, this.state.errorInfo);
            }
            
            // Default fallback UI
            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                    backgroundColor: '#fff3cd',
                    color: '#856404'
                }}>
                    <h2>Something went wrong</h2>
                    <p>An error occurred while rendering this component.</p>
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{ marginTop: '10px' }}>
                            <summary>Error Details</summary>
                            <pre style={{
                                marginTop: '10px',
                                padding: '10px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                overflow: 'auto'
                            }}>
                                {this.state.error.toString()}
                                {this.state.errorInfo.componentStack}
                            </pre>
                        </details>
                    )}
                    {this.props.showRetry && (
                        <button
                            onClick={() => {
                                this.setState({ hasError: false, error: null, errorInfo: null });
                                window.location.reload();
                            }}
                            style={{
                                marginTop: '10px',
                                padding: '8px 16px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Reload Page
                        </button>
                    )}
                </div>
            );
        }
        
        return this.props.children;
    }
}

export default ErrorBoundary;

